'use strict';

import { anchor } from './_anchor';
import { carousel } from './_carousel';

export const section = (() => {
    const showDetail = ($section, $body, target) => {
        if (target === '#cast') {
            carousel.init();
        }

        $section.addClass('is-show');

        $body.slideDown(200, () => {
            anchor.moveTo(null, target, () => {
                $body.addClass('is-show');
            });
        });
    };

    const hideDetail = ($section, $body, target) => {
        $section.removeClass('is-show');
        $body.removeClass('is-show');

        $body.slideUp(400, () => {
            anchor.moveTo(null, target);
        });
    };

    const init = () => {
        $('.js-toggle-detail').each((index, element) => {
            const $this = $(element);
            const $section = $this.parents('.section');
            const $body = $section.find('.section__body');
            const id = '#' + $this.data('id');

            $this.on('click', () => {
                if (!$section.hasClass('is-show')) {
                    showDetail($section, $body, id);
                } else {
                    hideDetail($section, $body, id);
                }
            });
        });
    };

    return {
        init: init
    };
})();
